import { render, staticRenderFns } from "./eliminarAdministrador.vue?vue&type=template&id=39a4491e&"
import script from "./eliminarAdministrador.vue?vue&type=script&lang=js&"
export * from "./eliminarAdministrador.vue?vue&type=script&lang=js&"
import style0 from "./eliminarAdministrador.vue?vue&type=style&index=0&id=39a4491e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports